require('es6-promise').polyfill()
import axios from 'axios'
import { forEachPolyfill, includesPolyfill } from '../../../js/modules/functions'

forEachPolyfill()
includesPolyfill()

const displayMatches = (matches, query, container, searchBar, backdrop) => {
	searchBar.classList.add('focused')
	backdrop.classList.add('focused')

	// container.style.display = 'block'
	let terms = []
	let items = []

	console.log(matches);
	matches.forEach(match => {

		if (match.term_id) {

			const { title, url, type, img, price } = match
			const term = `
			<a href="${match.url && match.url || '/categorie/' + match.slug}" class="search-bar-results__item type-${type}">    
				${img ? '<img src=' + img + '>' : ''}  
				<span class="result-content">  
					<span class="result-type">
						${type === 'Pagina' ? type : ''}
						${type === 'Blog' ? type : ''}
					</span>   
					${!match.term_id ? '<span class="result-title">' + title + '</span>' : ''}
					${match.term_id ? '<span class="result-title">' + match.name + '</span>' : ''}
				</span>

			</a>`

			terms.push(term)

		} else  {

			const { title, url, type, img, price } = match
			const item = `
				<a href="${match.url && match.url || '/categorie/' + match.slug}" class="search-bar-results__item type-${type}">    
					${img ? '<img src=' + img + '>' : ''}  
					<span class="result-content">  
						<span class="result-type">
							${type === 'Pagina' ? type : ''}
							${type === 'Blog' ? type : ''}
						</span>   
						${!match.term_id ? '<span class="result-title">' + title + '</span>' : ''}
						${match.term_id ? '<span class="result-title">' + match.name + '</span>' : ''}
					</span>

				</a>`
			items.push(item)
		}
	})

	container.innerHTML = '';

	if (typeof terms !== 'undefined' && terms.length > 0) {
		const termsList = document.createElement("div")
		termsList.classList.add('search-bar-results-terms');
		termsList.innerHTML = terms.join('');
		container.appendChild(termsList);
	}
	if (typeof items !== 'undefined' && items.length > 0) {
		const itemsList = document.createElement("div")
		itemsList.classList.add('search-bar-results-items');
		itemsList.innerHTML = items.join('');
		container.appendChild(itemsList);
	}

	if (query.length && items.length === 0) {
		// container.appendChild()`<span class="search-bar-results__item no-results">Geen resultaten voor "${query}" ...</span>`
	}
}

const findMatches = (query, results, container, searchBar, backdrop) => {
	const matches = results
		.filter(result => {
			const { title, name, excerpt } = result
			if(title) {
				return (title.toLowerCase().includes(query.toLowerCase()) || excerpt.toLowerCase().includes(query.toLowerCase()))
			} else if (name) {
				return (name.toLowerCase().includes(query.toLowerCase()))
			} else {
				return;
			}
		})
	displayMatches(matches, query, container, searchBar, backdrop)
}

export default function (parentSelector) {
	const parent = document.querySelector(parentSelector)
	if (!parent) return
	const input = parent.querySelector('.search-bar-field')
	const backdrop = parent.querySelector('.search-bar-backdrop');

	if (!input) return

	const searchBar = input.closest('.search-bar')
	const container = searchBar.querySelector('.search-bar-results')
	let results = null
	axios.get(`/wp-json/rest/data`)
		.then((res) => {
			results = res.data
			input.parentElement.classList.remove('loading');
		})
		.catch((err) => console.log(err))


	backdrop.addEventListener('click', () => {
		searchBar.classList.remove('focused');
		backdrop.classList.remove('focused');
	})

	input.addEventListener('keyup', () => {
		const query = input.value
		if (query.length > 1) {
			findMatches(query, results, container, searchBar, backdrop)
		} else {
			searchBar.classList.remove('focused');
			backdrop.classList.remove('focused');
			// container.style.display = 'none'
		}
	})

	// input.addEventListener('blur', () => {
	// 	container.style.display = 'none'
	// })
}
